import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-download-offer-dialog',
  templateUrl: './download-offer-dialog.component.html',
  styleUrls: ['./download-offer-dialog.component.scss']
})
export class DownloadOfferDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<DownloadOfferDialogComponent>) { }

  ngOnInit(): void { }

  public download(): void {
    this.dialogRef.close({ event: 'download' });
  }

  public close(): void {
    this.dialogRef.close({ event: 'close' });
  }
}
